export default __webpack_public_path__ + "static/media/XL INDONESIAN logo.8f8a4ddc.svg";